var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalContentBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 10.35L40.65 3.25C41.05 2.85 41.525 2.65 42.075 2.65C42.625 2.65 43.1 2.85 43.5 3.25C43.9 3.65 44.1 4.125 44.1 4.675C44.1 5.225 43.9 5.7 43.5 6.1L35 14.6C34.6 15 34.1333 15.2 33.6 15.2C33.0667 15.2 32.6 15 32.2 14.6L27.95 10.35C27.55 9.95 27.35 9.475 27.35 8.925C27.35 8.375 27.55 7.9 27.95 7.5C28.35 7.1 28.8167 6.9 29.35 6.9C29.8833 6.9 30.35 7.1 30.75 7.5L33.6 10.35ZM16.5 16C14.3 16 12.4167 15.2167 10.85 13.65C9.28333 12.0833 8.5 10.2 8.5 8C8.5 5.8 9.28333 3.91667 10.85 2.35C12.4167 0.783333 14.3 0 16.5 0C18.7 0 20.5833 0.783333 22.15 2.35C23.7167 3.91667 24.5 5.8 24.5 8C24.5 10.2 23.7167 12.0833 22.15 13.65C20.5833 15.2167 18.7 16 16.5 16ZM0.5 28V26.4C0.5 25.2667 0.791667 24.225 1.375 23.275C1.95833 22.325 2.73333 21.6 3.7 21.1C5.76667 20.0667 7.86667 19.2917 10 18.775C12.1333 18.2583 14.3 18 16.5 18C18.7 18 20.8667 18.2583 23 18.775C25.1333 19.2917 27.2333 20.0667 29.3 21.1C30.2667 21.6 31.0417 22.325 31.625 23.275C32.2083 24.225 32.5 25.2667 32.5 26.4V28C32.5 29.1 32.1083 30.0417 31.325 30.825C30.5417 31.6083 29.6 32 28.5 32H4.5C3.4 32 2.45833 31.6083 1.675 30.825C0.891667 30.0417 0.5 29.1 0.5 28Z",
    fill: "#467077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalContentBlockIcon);
export default __webpack_public_path__ + "static/media/approval-content-block-icon.6a90be938efe8d7ed3702edc32a82997.svg";
export { ForwardRef as ReactComponent };